<div class="card card-user">
  <div class="card-header">
    <h4 class="card-title">Subscriptions</h4>
  </div>
  <div class="card-body">
    <app-subscription [isSaving]="isSaving" (subscriptionAdded)="onSubscriptionAdded($event)" [currentProject]="currentProject" [currentApiId]="currentApiId"></app-subscription>
  </div>
</div>
